// extracted by mini-css-extract-plugin
module.exports = {"CARD_RATIO-card":".625","CARD_RATIO-square":"1","container":"SeeAllCards_container__jANKG"};